import { DESKTOP_MIN_WIDTH } from 'constants';
import useLang from 'hooks/useLang';
import styled from 'styled-components';
import { fontSize14Mixin, fontSize16Mixin, paragraph500Mixin } from 'styles';

const AccountIncorrectInform = () => {
  const { t } = useLang();

  return (
    <AccountIncorrectInformStyled>
      {t('login_bad_credentials')}
    </AccountIncorrectInformStyled>
  );
};

const AccountIncorrectInformStyled = styled.div`
  ${paragraph500Mixin};
  ${fontSize14Mixin};
  padding: 10px 16px;
  width: 100%;
  height: fit-content;
  background: var(--bg-info);
  border-radius: 8px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    ${fontSize16Mixin};
  }
`;

export default AccountIncorrectInform;
